export default __webpack_public_path__ + "static/media/bellIcon2.4febad38.svg";